import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import MusicPage from '../MainPage/MusicPage';
import PartyMembers from '../AdminPages/AllClients';
import PaymentPlan from '../AdminPages/PaymentManagement';
import Support from '../AdminPages/TourEssentials';
import ItineraryPage from '../AdminPages/ItineraryAdmin';
import Logo from "../AllImages/MainLogo.png";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('participants');
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  
  // Replace this with the real user name if available
  const userName = "John Smith";

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      // Navigate back to the HomePage
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
      
    }
  };

  return (
    <div className="bg-white shadow-md">
      {/* Top Nav Bar */}
      <div className="flex items-center justify-between px-6 py-3">
        {/* Left: Brand + Nav Items */}
        <div className="flex items-center space-x-6">
        <img src={Logo} alt="Company Logo" className="h-10 w-auto" />
          <nav className="hidden md:flex space-x-6">
            <button
              onClick={() => setActiveTab('participants')}
              className={`${
                activeTab === 'participants' ? 'text-blue-600' : 'text-gray-700'
              } hover:text-blue-600 transition-colors`}
            >
              Participants
            </button>
            <button
              onClick={() => setActiveTab('itinerary')}
              className={`${
                activeTab === 'itinerary' ? 'text-blue-600' : 'text-gray-700'
              } hover:text-blue-600 transition-colors`}
            >
              Itinerary
            </button>
            <button
              onClick={() => setActiveTab('payment')}
              className={`${
                activeTab === 'payment' ? 'text-blue-600' : 'text-gray-700'
              } hover:text-blue-600 transition-colors`}
            >
              Payment Plan
            </button>
            <button
              onClick={() => setActiveTab('music')}
              className={`${
                activeTab === 'music' ? 'text-blue-600' : 'text-gray-700'
              } hover:text-blue-600 transition-colors`}
            >
              Music
            </button>
            <button
              onClick={() => setActiveTab('Communicate')}
              className={`${
                activeTab === 'Communicate' ? 'text-blue-600' : 'text-gray-700'
              } hover:text-blue-600 transition-colors`}
            >
              Communicate
            </button>
          </nav>
        </div>

        {/* Right: Contact & User Info */}
        <div className="flex items-center space-x-6 relative">
          <div className="text-gray-700 hidden sm:block">+1 (555) 2023</div>

          {/* User Dropdown */}
          <div 
            className="flex items-center space-x-1 cursor-pointer hover:text-blue-600 transition-colors"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <span>{userName}</span>
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          {showDropdown && (
            <div className="absolute right-0 top-12 w-40 bg-white border rounded shadow-lg z-10">
              <button
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Profile
              </button>
              <button
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Settings
              </button>
              <button
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Main Content Area */}
      <div className="p-6">
        {activeTab === 'participants' && <PartyMembers />}
        {activeTab === 'itinerary' && <ItineraryPage />}
        {activeTab === 'payment' && <PaymentPlan />}
        {activeTab === 'music' && <MusicPage />}
        {activeTab === 'Communicate' && <Support />}
      </div>
    </div>
  );
};

export default AdminDashboard;
